import LOGO from '../../assets/logo.png'
import LOGOYORK from '../../assets/york.png'

export function Footer() {
    return (
        <footer className="bg-card border-t border-border py-2 d-none">
            <div className="container mx-auto px-6">
                <div className="flex flex-col md:flex-row justify-between items-center gap-4">

                    {/* Logos */}
                    <div className="flex gap-4 items-center">
                        <img src={LOGO} width={100} className="opacity-90 hover:opacity-100 transition-opacity" />
                    </div>

                    {/* Links do Footer */}
                    <div className="flex flex-col md:flex-row items-center gap-4 text-xs text-muted-foreground">

                        <a
                            href="/contato-suporte"
                            className="text-muted-foreground hover:text-primary transition-colors flex items-center gap-1"
                        >
                            <i className='fa fa-headphones' />
                            Contatar Suporte
                        </a>

                        <span className="hidden md:block text-border">|</span>

                        <p className="text-muted-foreground">
                            © 2026 Mydash — Desenvolvido por Antônio
                        </p>

                    </div>
                </div>
            </div>
        </footer>
    );
}
